export default {
  showError500: ({ commit }, payload) => commit('showError500', payload),

  closeError500: ({ commit }) => commit('closeError500'),

  setJsonErrors: ({ commit }, payload) => commit('jsonErrors', payload)
};
